import React from 'react'
import classnames from 'classnames'
import classes from './index.module.scss'
const { styles } = classes

const PainItem = ({ pain, className, selected, onClick }) => {
  return (
    <div className={classnames(styles, className)}>
      <div
        className={classnames('pain-item', { selected: selected })}
        onClick={onClick}
      >
        <div className={classnames('pain-inner')}>
          {selected && <div className='pain-selected-bg' />}
          <img src={pain.image} alt={pain.name} />
          <div className='pain-item-name'>{pain.id}</div>
        </div>
      </div>
    </div>
  )
}

export default PainItem
